import './ARJack.css';
import { useState } from "react";
import './Header.css';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';

import { Link } from "react-router-dom";

import HeroImg from '../img/Firstanniv/hero_img.webp';
import HeroTextImg from '../img/Firstanniv/hero_copy.svg';
import wombLinkImg from '../img/Firstanniv/womb_link.webp';
import halloweenLinkImg from '../img/Firstanniv/halloween23.webp';
import comingsoonImg from '../img/Firstanniv/coming soon.webp';
import aboutImg from '../img/Firstanniv/about_img.png';

import headingIcon from '../img/Firstanniv/heading_icon.webp';
import XIcon from '../img/icons/x_logo.svg';
import OpenseaIcon from '../img/icons/opensea_logo.svg';
import FooterLogo from '../img/Firstanniv/footer_logo.webp';

import Footer from './Footer';

export default function Firstanniv() {
    const Header = () => {
        const [isModalOpen, setIsModalOpen] = useState(false);

        const Menu = () => {
            return (
                <div className="Header__menu">
                    <div className="Header__logo glitchPatternInfinite05">
                        <Link to="/">
                            <picture>
                                <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                                <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                            </picture>
                        </Link>
                    </div>
                    <div className="Header__rightContainer">

                        <div className="Header__icon">
                            <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoOpenseaWebp} />
                                    <img src={logoOpensea} alt="OpenSea link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite03">
                            <a href="https://discord.gg/bosotokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoDiscordWebp} />
                                    <img src={logoDiscord} alt="Discord link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite04">
                            <a href="https://twitter.com/BosoTokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoTwitterWebp} />
                                    <img src={logoTwitter} alt="Twitter link" />
                                </picture>
                            </a>
                        </div>

                    </div>
                </div>
            )
        }

        return (

            <>
                {isModalOpen ? (
                    <header className="Header open" id="HeaderLogo">
                        <Menu />
                        <div className="Header__Modal">
                            <Menu />
                            <nav className="Header__nav--sp">
                                <ul>
                                    {/* <li><Link to="/gallery" onClick={() => setIsModalOpen(false)}>Gallery</Link></li>
                                    <li><Link to="/revving" onClick={() => setIsModalOpen(false)}>Revving</Link></li>
                                    <li><a href="#about" onClick={() => setIsModalOpen(!isModalOpen)}>About</a></li> */}

                                    <li><a href="#About">About</a></li>
                                    <li><a href="#Contents">Contents</a></li>
                                    <li><a href="#Prize">Prize</a></li>
                                    <li><a href="#Partnership">Partnership</a></li>
                                </ul>
                            </nav>
                        </div>
                    </header>

                ) : (
                    <header className="Header" id="HeaderLogo">
                        <Menu />
                    </header>
                )}
            </>

        );
    }

    const AboutItem = ({ children, title }) => {
        return (
            <div className="ARJack__about__item">
                <h3 className="ARJack__about__item__h3">{title}</h3>
                <div className="ARJack__about__item__content">
                    {children}
                </div>
            </div>
        )
    }

    const GridItem = (props) => {
        return (
            <div className="ARJack__GridItem">
                <div className="ARJack__GridItem__img">
                    <img src={props.img} alt={props.alt} />
                </div>
                <p className="ARJack__GridItem__name">{props.name}</p>
                <p className="ARJack__GridItem__prize">{props.prize}</p>
            </div>
        )
    }

    return (
        <>
            {/* <NoiseEffect /> */}
            <Header />
            <div className="firstanniv">

                <div className="ARJack__heroImg">
                    <img className="ARJack__heroMainImg" src={HeroImg} alt="BOSO TOKYO 1st ANNIV." />
                </div>

                <div className="firstanniv__main">
                    <img className="firstanniv__heroTextImg" src={HeroTextImg} alt="BŌSŌ TOKYOの1周年。この1年を駆け抜けたBŌSŌ CREWとの祝祭でありクリエイターや企業との新たなつながりが生まれる場。２本のバットがクロスする。狂宴であり、共演であり、強縁の象徴を掲げて。" />
                    <section className='firstanniv_linkCardContainer'>
                        <div className='firstanniv_linkCard'>
                            {/* <Link to="/1stanniv/231029womb/">
                                <img src={wombLinkImg} alt="231029womb" />
                            </Link> */}
                            <a href="https://www.bosotokyo.com/1stanniv/231029womb/" target='_blank'>
                                <img src={wombLinkImg} alt="231029womb" />
                            </a>
                        </div>
                        <div className='firstanniv_linkCard'>
                            <a href="https://alpha-u.io/event/halloween23?utm_medium=referral&utm_source=wwd&utm_campaign=vh2023&utm_id=0001" target='_blank'>
                                <img src={halloweenLinkImg} alt="halloween23" />
                            </a>
                        </div>
                        <div className='firstanniv_linkCard'>
                            <img src={comingsoonImg} alt="Coming soon" />
                        </div>
                    </section>

                    <section className="ARJack__about" id="About">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">ABOUT</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>
                    </section>

                    <section className="ARJack__Partnership" id="Partnership">
                        <div className="ARJack__Partnership__img">
                            <img src={aboutImg} alt="img" />
                        </div>

                        <h3 className='firstanniv_h4'>BOSO TOKYO</h3>
                        <p className="firstanniv_p">
                            BŌSŌ TOKYO -暴走東京- は、日本を代表するイラストレーター「天神英貴」が、暴走族カルチャー×サイバーSFの世界観で描く、メタバース時代のアイデンティティブランドをつくるプロジェクトです。ユーティリティーとして、唯一無二のアートワーク、そして、PFPに留まらず、クオリティの高い3Dデータの配布やメタバース空間に持ち込めるアバターを用意します。さらに商用利用権の提供や、専用のコミュニティやイベントへのアクセスが可能になります。
                        </p>
                        <div className="ARJack__Partnership__partner__linkCnotainer">
                            <a className="ARJack__Partnership__partner__link" href="https://www.bosotokyo.com/" target="_blank">OFFICIAL Site</a>
                            <a className="ARJack__Partnership__partner__link" href="https://twitter.com/BosoTokyo" target="_blank"><img src={XIcon} alt="X" /></a>
                            <a className="ARJack__Partnership__partner__link" href="https://opensea.io/collection/bosotokyo-official" target="_blank"><img src={OpenseaIcon} alt="Opensea" /></a>
                        </div>
                    </section>


                    <footer className='firstanniv__footer'>
                        <div className='firstanniv__footer__copy'></div>
                        <div className='firstanniv__footer__logo'>
                            <Link to="/" >
                                <img src={FooterLogo} alt="BOSO TOKYO" />
                            </Link>
                        </div>
                    </footer>
                </div>


            </div>
            {/* <Footer /> */}
        </>
    );
}